/**
 * Track Title
 * 
 * @Author: Focci
 * @Date: 2023-08-17 14:58:32
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 14:58:32
 */

// import PropTypes from 'prop-types'

export default function TrackTitle({ label }) {
  return (
    <div className="text-center text-f1.2 font-medium my-6">
      {label}
    </div>
  )
}

// TrackTitle.propTypes = {
//   className: PropTypes.string,
// }
